export default __webpack_public_path__ + "static/media/Neophyte's Gloves of the Kingmaker.62e2c0c2.jpg";